import { useState } from "react";
import { ListGroup, Button, Modal } from "react-bootstrap";
//Api 
import { PosIntegrationFetchAPI } from "../../api/PosIntegrations";
import { RenderIf } from "../utils/RenderIf";

//Function to list the integrations of the business
const IntegrationsList = ({ business, branchoffice, token }) => {
    //States
    const [showModal, setShowModal] = useState(false);
    const [selectedIntegration, setSelectedIntegration] = useState({
        name: null,
        pos_integration_id: null
    });
    const [configParams, setConfigParams] = useState([]);
    // Handler for configuration button click
    const handleConfigClick = (integration) => {
        console.log("Configuring integration:", integration);
        setSelectedIntegration(integration);
        setShowModal(true);
        getConfigParams(integration);
    };

    //Handler to get the configuration params of the selected integration
    const getConfigParams = async (integration) => {
        try {
            const configParams = await PosIntegrationFetchAPI.getPosIntegrationParamsByBranch(integration.pos_integration_id, branchoffice.id, token);
            setConfigParams(configParams.data.params_values);
        } catch (err) {
            console.error("Error fetching configuration params:", err);
        }
    };

    //Config params to manage
    const handleConfigChange = (paramId, value) => {
        setConfigParams((prevParams) =>
            prevParams.map((param) =>
                param.pos_integration_param_value_id === paramId ? { ...param, value } : param
            )
        );
    };

    //Function to manage the name of the config param
    const getConfigParamName = (param) => {
        switch (param.param_name) {
            case "auto_accept_order":
                return "Auto aceptar pedido";
            case "smartpay_pedidosya_default_machine_code":
                return "Código de máquina predeterminado para manejar PedidosYa";
            default:
                return param.param_name;
        }
    };

    //Function to update the configuration params
    const updateConfigParams = async () => {
        try {
            let updateJustEditable = configParams.filter(param => param.editable === 1);
            await PosIntegrationFetchAPI.updatePosIntegrationParams(selectedIntegration.pos_integration_id, branchoffice.id, token, updateJustEditable);
            setShowModal(false);
        } catch (err) {
            console.error("Error updating configuration params:", err);
        }
    };

    return (
        <div>
            <ListGroup>
                {business.posIntegrations.map((integration, index) => (
                    <ListGroup.Item key={index}>
                        <div className="row">
                            <div className="col-6">
                                {integration.name}
                            </div>
                            <div className="col-6">
                                <Button bg="primary" onClick={() => handleConfigClick(integration)}>Configurar</Button>
                            </div>
                        </div>
                    </ListGroup.Item>
                ))}
            </ListGroup>
            {/** Modal for integration configuration */}
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Configurar Integración</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <p>Configurando integración para: {selectedIntegration?.name || "Sin nombre"}</p>
                    {/** We list the configuration parameters */}
                    {configParams.map((param) => (
                        <RenderIf isTrue={param.editable === 1} key={"integration-id" + param.pos_integration_param_value_id}>
                            <div className="mb-3">
                                <label>{getConfigParamName(param)}</label>
                                <input
                                    type="text"
                                    value={param.value}
                                    onChange={(e) => handleConfigChange(param.pos_integration_param_value_id, e.target.value)}
                                />
                            </div>
                        </RenderIf>
                    ))}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={updateConfigParams}>
                        Guardar Cambios
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}



export default IntegrationsList;
